module.exports = __webpack_public_path__ + "static/media/V2_15.876cbad9.png";